import { render, staticRenderFns } from "./HomeFaq.vue?vue&type=template&id=a84404ba&scoped=true"
import script from "./HomeFaq.js?vue&type=script&lang=js&external"
export * from "./HomeFaq.js?vue&type=script&lang=js&external"
import style0 from "./HomeFaq.scss?vue&type=style&index=0&id=a84404ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84404ba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotAccordionItem: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/AccordionItem/AccordionItem.vue').default,HotAccordion: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Accordion/Accordion.vue').default})
